import { OrgData, UserData } from "./types";

type FeatureGate = (data: { user?: UserData; org?: OrgData }) => boolean;

const FEATURE_FLAGS = {
  hasSingleRepoFailOpen:
    "Turns on the ability to set fail-open on a per-repo basis",
  hasTeamsTier: "Has the upgraded version of the Semgrep App",
  hasS3Integration: "Adds S3 as an integration option",
  hasTeamsTierTrial:
    "Has the upgraded version of the Semgrep App, but on a trial basis. Should be used in *addition* to hasTeamsTier",
  hasSemgrepRunnerLambda:
    "Is using the version of semgrep-runner backed by a lambda",
  isNolicy:
    "Replaces the dashboard with the 2021 Aug version that uses a Rule Board instead of Policies.",
  hasDeeperRun: "Has the experimental Deep Semgrep runner",
  hasSCA:
    "Has experimental Software Composition Analysis (3rd party code security) product",
  hasNonStandardTOC:
    "Does not display 'terms' on the app footer or when creating an account (for legal reasons)",
} as const;

type FN = keyof typeof FEATURE_FLAGS;

export const FEATURE_FLAG_NAMES = Object.getOwnPropertyNames(
  FEATURE_FLAGS
) as FN[];

// Value of each gate checks if a corresponding feature flag is set on the organization
const generate = () => {
  const o = {} as Record<FN, FeatureGate>;
  const currentTime = new Date().getTime() / 1000;
  for (let fn of FEATURE_FLAG_NAMES) {
    o[fn as FN] = ({ org }) =>
      !!org?.features?.find(
        (f) =>
          f.name === fn &&
          (!f.expires_at || parseInt(f.expires_at) > currentTime)
      );
  }
  return o;
};

// Feature's type only has properties with names in FEATURE_FLAG_NAMES
const Feature = generate();

export default Feature;
